export const PRICE_VERIFY_REQUIRED = 'PriceVerifyRequired';
export const CASHIER_BARCODE_IN_TRANSACTION = 'CashierBarcodeInTransactionError';
export const INVALID_BARCODE = 'InvalidBarcode';
